import React, { Component } from "react";
import styled from "styled-components";
import ReactResizeDetector from "react-resize-detector";
import Height from "../Height";
Height();

const Container = styled.div`
  top: -15px;
  display: flex;
  width: 100%;
  height: 100vh;
  /* min-height: 100%; */
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 320px) and (max-width: 480px) {
    height: 100vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 100);
  }
`;

class Cont extends Component {
  onResize = () => console.log("132");
  render() {
    return (
      <>
        <ReactResizeDetector handleHeight onResize={Height} />
        <Container>{this.props.children}</Container>
      </>
    );
  }
}

export default Cont;
